import React, { useContext } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';

import './Landing.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { headerData } from '../../data/headerData';
import { socialsData } from '../../data/socialsData';

import { FaLinkedin, FaGithub } from 'react-icons/fa';

function Landing() {
    const { drawerOpen } = useContext(ThemeContext);

    return (
        <div className='landing'>
            <div className='landing__atmosphere' aria-hidden='true'>
                <div className='landing__orb landing__orb--1'>
                    <div className='landing__orb-inner' />
                </div>
                <div className='landing__orb landing__orb--2'>
                    <div className='landing__orb-inner' />
                </div>
                <div className='landing__orb landing__orb--3'>
                    <div className='landing__orb-inner' />
                </div>
            </div>
            <div className='landing--container'>
                <img
                    src={headerData.image}
                    alt=''
                    className='landing--img'
                    style={{
                        opacity: `${drawerOpen ? '0' : '1'}`,
                    }}
                />
                <div className='landing--container-right'>
                    <div className='lcr--content'>
                        <h6>{headerData.title}</h6>
                        <h1>{headerData.name}</h1>
                        <p>{headerData.desciption}</p>

                        <div className='lcr-buttonContainer'>
                            <NavLink
                                to='/#contacts'
                                smooth={true}
                                spy='true'
                                duration={2000}
                                className='landing__contactBtn'
                            >
                                Contact
                                <span
                                    className='landing__contactBtn-arrow'
                                    aria-hidden='true'
                                >
                                    →
                                </span>
                            </NavLink>
                        </div>
                        <div className='landing__socialRow'>
                            {socialsData.linkedIn && (
                                <a
                                    href={socialsData.linkedIn}
                                    target='_blank'
                                    rel='noreferrer'
                                    className='landing__socialBtn'
                                    aria-label='LinkedIn'
                                >
                                    <FaLinkedin className='landing__socialIcon' />
                                </a>
                            )}
                            {socialsData.github && (
                                <a
                                    href={socialsData.github}
                                    target='_blank'
                                    rel='noreferrer'
                                    className='landing__socialBtn'
                                    aria-label='GitHub'
                                >
                                    <FaGithub className='landing__socialIcon' />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Landing;
